/* Vinelor theme.js — animations + drawers + cart ajax (idempotent) */
(function () {
  'use strict';
  var DESIGN = window.Shopify && Shopify.designMode;

  /* ---------- reveal ---------- */
  function reveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.in),[data-reveal-stagger]:not(.in)');
    if (!els.length) return;
    if (DESIGN || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.in),[data-reveal-stagger]:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) el.classList.add('in');
      });
    }, 1200);
  }

  /* ---------- scroll fill (mot par mot) ---------- */
  function scrollFill() {
    document.querySelectorAll('[data-scrollfill]:not(.sf-ready)').forEach(function (el) {
      el.classList.add('sf-ready');
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'fw';
        s.textContent = w;
        el.appendChild(s);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
    var els = document.querySelectorAll('[data-scrollfill].sf-ready');
    if (!els.length) return;
    function update() {
      els.forEach(function (el) {
        var spans = el.querySelectorAll('.fw');
        if (DESIGN) { spans.forEach(function (s) { s.classList.add('on'); }); return; }
        var r = el.getBoundingClientRect();
        var start = innerHeight * 0.82, end = innerHeight * 0.32;
        var p = (start - r.top) / (start - end);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * spans.length);
        spans.forEach(function (s, i) { s.classList.toggle('on', i < n); });
      });
    }
    if (!scrollFill.bound) {
      scrollFill.bound = true;
      var t = false;
      addEventListener('scroll', function () {
        if (!t) { requestAnimationFrame(function () { update(); t = false; }); t = true; }
      }, { passive: true });
    }
    update();
  }

  /* ---------- wipe ---------- */
  function wipe() {
    var els = document.querySelectorAll('[data-wipe]:not(.in)');
    if (!els.length) return;
    if (DESIGN || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- header ---------- */
  function header() {
    if (header.bound) return; header.bound = true;
    addEventListener('scroll', function () {
      document.body.classList.toggle('hd--scrolled', scrollY > 8);
    }, { passive: true });
  }

  /* ---------- drawers ---------- */
  function closeDrawers() {
    document.querySelectorAll('.drawer.open').forEach(function (d) { d.classList.remove('open'); });
    document.querySelectorAll('.is-menu-drawer-open').forEach(function (el) { el.classList.remove('is-menu-drawer-open'); });
    document.body.classList.remove('drawer-open', 'drawer-menu-open', 'drawer-cart-open');
  }
  function openDrawer(sel) {
    var d = document.querySelector(sel);
    if (!d) return;
    closeDrawers();
    d.classList.add('open');
    document.body.classList.add('drawer-open');
    if (d.classList.contains('drawer--menu')) {
      document.body.classList.add('drawer-menu-open');
      var section = d.closest('.shopify-section');
      if (section) section.classList.add('is-menu-drawer-open');
    }
    if (d.classList.contains('drawer--cart')) document.body.classList.add('drawer-cart-open');
  }
  function drawers() {
    if (drawers.bound) return; drawers.bound = true;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-drawer-open]');
      if (t) { e.preventDefault(); openDrawer(t.getAttribute('data-drawer-open')); return; }
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-scrim]')) {
        e.preventDefault(); closeDrawers(); return;
      }
      var st = e.target.closest('[data-search-toggle]');
      if (st) {
        e.preventDefault();
        var s = document.querySelector('.hd-search');
        if (s) { s.classList.toggle('open'); var i = s.querySelector('input'); if (s.classList.contains('open') && i) i.focus(); }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawers(); var s = document.querySelector('.hd-search'); if (s) s.classList.remove('open'); }
    });
  }

  /* ---------- cart ajax + slide-cart ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/,00$/, '') + ' €';
  }
  function renderCart(cart) {
    var wrap = document.querySelector('[data-cart-items]');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
    var save = 0;
    cart.items.forEach(function (it) {
      if (it.original_line_price > it.final_line_price) save += it.original_line_price - it.final_line_price;
    });
    var saveEl = document.querySelector('[data-cart-savings]');
    if (saveEl) {
      saveEl.style.display = save > 0 ? '' : 'none';
      var sv = saveEl.querySelector('b'); if (sv) sv.textContent = money(save);
    }
    /* paliers */
    var tiers = document.querySelector('[data-cart-tiers]');
    if (tiers) {
      var t1 = parseInt(tiers.getAttribute('data-t1') || '0', 10) * 100;
      var t2 = parseInt(tiers.getAttribute('data-t2') || '0', 10) * 100;
      var max = t2 || t1 || 1;
      var pct = Math.min(100, cart.total_price / max * 100);
      var fill = tiers.querySelector('.sc__fill'); if (fill) fill.style.width = pct + '%';
      tiers.querySelectorAll('.sc__steps b').forEach(function (b) {
        var v = parseInt(b.getAttribute('data-at') || '0', 10) * 100;
        b.classList.toggle('on', cart.total_price >= v);
      });
      var ship = document.querySelector('[data-ship-msg]');
      if (ship && t1) {
        var rest = t1 - cart.total_price;
        ship.innerHTML = rest > 0
          ? 'Plus que <strong>' + money(rest) + '</strong> pour la <strong>livraison offerte</strong>'
          : '<strong>Livraison premium offerte</strong> sur votre commande';
      }
    }
    if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="sc__empty"><svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1" style="margin-inline:auto"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><div class="t-h3">Votre cave est vide</div><p>Nos caves de service et de vieillissement vous attendent.</p></div>';
      return;
    }
    wrap.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '';
      return '<div class="sc__item" data-key="' + it.key + '">'
        + (img ? '<img class="sc__img" src="' + img + '" alt="" loading="lazy">' : '<div class="sc__img"></div>')
        + '<div><div class="sc__t">' + it.product_title + '</div>'
        + (it.variant_title ? '<div class="sc__v">' + it.variant_title + '</div>' : '')
        + '<div class="sc__row"><span class="sc__qty"><button data-qty="-1" aria-label="Réduire">&minus;</button><span>' + it.quantity + '</span><button data-qty="1" aria-label="Augmenter">+</button></span>'
        + '<span class="sc__price">' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price) + '</span></div></div></div>';
    }).join('');
  }
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(body) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return fetchCart();
    }).then(function () { openDrawer('.drawer--cart'); });
  }
  function cartAjax() {
    if (cartAjax.bound) return; cartAjax.bound = true;
    fetchCart();
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('form[action*="/cart/add"]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('disabled', ''); btn.classList.add('loading'); }
      var fd = new FormData(f);
      var body = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
      addToCart(body).catch(function () { f.submit(); }).finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('loading'); }
      });
    });
    document.addEventListener('click', function (e) {
      var up = e.target.closest('[data-upsell-add]');
      if (up) {
        e.preventDefault();
        up.setAttribute('disabled', '');
        addToCart({ id: up.getAttribute('data-upsell-add'), quantity: 1 })
          .finally(function () { up.removeAttribute('disabled'); });
        return;
      }
      var q = e.target.closest('[data-qty]');
      if (q) {
        var item = q.closest('.sc__item');
        var span = item.querySelector('.sc__qty span');
        var cur = parseInt(span.textContent, 10);
        changeQty(item.getAttribute('data-key'), Math.max(0, cur + parseInt(q.getAttribute('data-qty'), 10)));
      }
    });
  }

  /* ---------- galerie PDP ---------- */
  function gallery() {
    document.querySelectorAll('[data-gallery]:not(.g-ready)').forEach(function (g) {
      g.classList.add('g-ready');
      var main = g.querySelector('.pdp__main img');
      var thumbs = g.querySelectorAll('.pdp__thumb');
      var idx = 0;
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (!main || i === idx) return;
          main.src = t.getAttribute('data-full');
          if (t.getAttribute('data-alt')) main.alt = t.getAttribute('data-alt');
          main.classList.remove('slide-l', 'slide-r');
          void main.offsetWidth;
          main.classList.add(i > idx ? 'slide-l' : 'slide-r');
          thumbs.forEach(function (x) { x.classList.remove('on'); });
          t.classList.add('on');
          idx = i;
        });
      });
    });
  }

  /* ---------- drag pour rangées scrollables ---------- */
  function dragScroll() {
    document.querySelectorAll('.hscroll:not(.d-ready),.pdp__thumbs:not(.d-ready)').forEach(function (el) {
      el.classList.add('d-ready');
      var down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = el.scrollLeft;
      });
      addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) { moved = true; el.classList.add('drag'); }
        el.scrollLeft = sl - dx;
      });
      addEventListener('pointerup', function () {
        down = false;
        setTimeout(function () { el.classList.remove('drag'); }, 30);
      });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    });
  }

  /* ---------- countdown roulant ---------- */
  function timers() {
    var els = document.querySelectorAll('[data-countdown]:not(.t-ready)');
    els.forEach(function (el) { el.classList.add('t-ready'); });
    var all = document.querySelectorAll('[data-countdown].t-ready');
    if (!all.length || timers.bound) { if (all.length) tick(); return; }
    timers.bound = true;
    function tick() {
      document.querySelectorAll('[data-countdown].t-ready').forEach(function (el) {
        var hours = parseFloat(el.getAttribute('data-countdown')) || 24;
        var period = hours * 3600000;
        var rest = period - (Date.now() % period);
        var h = Math.floor(rest / 3600000), m = Math.floor(rest % 3600000 / 60000), s = Math.floor(rest % 60000 / 1000);
        el.textContent = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- marquee : duplication pour boucle ---------- */
  function marquees() {
    document.querySelectorAll('.mq__track:not(.m-ready)').forEach(function (tr) {
      tr.classList.add('m-ready');
      tr.innerHTML += tr.innerHTML;
    });
  }

  /* ---------- video sections play toggle ---------- */
  function videos() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-video-toggle]');
      if (!b) return;
      var v = b.closest('[data-video-wrap]').querySelector('video');
      if (!v) return;
      if (v.paused) { v.play(); b.classList.add('playing'); } else { v.pause(); b.classList.remove('playing'); }
    });
  }
  videos.bound = false;

  function initAll() {
    marquees(); reveal(); scrollFill(); wipe(); header(); drawers(); cartAjax(); gallery(); dragScroll(); timers();
    if (!videos.bound) { videos.bound = true; videos(); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  /* fix éditeur : ré-init à chaque manipulation de section */
  if (DESIGN) {
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:select', function () { reveal(); marquees(); });
    document.addEventListener('shopify:block:select', function () { reveal(); });
  }
})();
